<h2 mat-dialog-title>Leave Feedback</h2>

<mat-dialog-content>
  @if (submitted()) {
    <p class="success-message">Thank you for your feedback!</p>
  } @else {
    @if (error()) {
      <p class="error-message">{{ error() }}</p>
    }

    <form [formGroup]="form" (ngSubmit)="onSubmit()" id="feedback-form">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Subject (optional)</mat-label>
        <input
          matInput
          formControlName="title"
          placeholder="What's this about?"
        />
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Message</mat-label>
        <textarea
          matInput
          formControlName="content"
          rows="5"
          placeholder="Share your thoughts..."
        ></textarea>
        @if (form.controls.content.hasError('required')) {
          <mat-error>Message is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Contact info (optional)</mat-label>
        <input
          matInput
          formControlName="contactInfo"
          placeholder="Email or other contact"
        />
      </mat-form-field>
    </form>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (submitted()) {
    <bn-button appearance="flat" color="primary" (click)="close()"
      >Close</bn-button
    >
  } @else {
    <bn-button
      appearance="button"
      type="button"
      mat-dialog-close
      [disabled]="isSubmitting()"
    >
      Cancel
    </bn-button>
    <bn-button
      appearance="flat"
      color="primary"
      type="submit"
      (click)="onSubmit()"
      form="feedback-form"
      [disabled]="form.invalid || isSubmitting()"
    >
      {{ isSubmitting() ? 'Sending...' : 'Send Feedback' }}
    </bn-button>
  }
</mat-dialog-actions>
